import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { getOrganization } from '../../features/organizationSlice';
import { getData, setIsSaved } from '../../features/mitakeSlice';

function Initial({ children }) {
  const { orgId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getData(orgId));
    dispatch(getOrganization(orgId));
    dispatch(setIsSaved(false));
  }, []);

  return <>{children}</>;
}

export default Initial;
